import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const EQUIPMENT_ENDPOINT = 'equipment';
export const EQUIPMENT_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(EQUIPMENT_ENDPOINT);

export const equipmentStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const LISTA_EQUIPMENT_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'equipmentId',
    label: 'Equipment id',
    field: 'equipmentId',
    type:'text'
  },
  {
    name: 'note',
    label: 'Note',
    field: 'note',
    type:'text'
  },
  {
    name: 'code',
    label: 'Codice',
    field: 'code',
    type:'text'
  },
  {
    name: 'description',
    label: 'Descrizione',
    field: 'description',
    type:'text'
  },
  {
    name: 'waterSupplyCompanyId',
    label: 'Descrizione',
    field: 'waterSupplyCompanyId',
    type: 'number'
  },
];

export const LISTA_EQUIPMENT_VISIBLE_COLUMNS = [
  'select',
  'code',
  'description',
  'note',
  'azioni',
];

